/* eslint-disable no-console, no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FilterTabItem } from '../media-gallery-filters/FilterTab';
import { FilterSetList } from '../media-gallery-filters/FilterList';
import { getIdFromAssetUrl } from '../../modules/widen-utils';

import MediaGalleryList from './MediaGalleryList';
import Modal from '../modal/Modal';
import Lazyload from '../../modules/lazyload';
import InPageNav from '../../modules/in-page-nav';
import ToggleContentToModal from '../../modules/toggle-content-to-modal';

class LightGalleryUtils {
  constructor(options) {
    this.closeModal = options.closeModal;
    this.isComplete = options.isComplete;
    this.mediaItems = options.mediaItems;
    this.modal = options.modal;
    this.openModal = options.openModal;
    this.isDynamicLoad = false;
    this.lgDiv = document.getElementById('media-gallery-list');

    this.getHashItem = () => {
      // Check for id in url hash
      // If hash exists load modal w/ image
      // data associated w/ that hash value
      const { location } = window;
      const { hash } = location;
      const hashId = hash.substr(1, hash.length);
      // console.log(hashId);
      let hashItem;
      if (hashId !== '' && hashId !== 'media-gallery-list') {
        hashItem = this.mediaItems.filter(item => item.type === 'Image').find(item => item.imageUrl.indexOf(hashId) !== -1);
      }
      return hashItem;
    };

    this.onUpdate = (event) => {
      // console.log(`LightGalleryUtils, onUpdate: ${event.detail.index}, mediaItems length: ${this.mediaItems.length}`);
      const item = this.mediaItems[event.detail.index];
      // console.log(item);
      this.openModal(item);
      // Add hash
      const { imageUrl } = item;
      const id = getIdFromAssetUrl(imageUrl);
      window.location.hash = id;
    };

    this.onClose = () => {
      // console.log(`LightGalleryUtils, onClose, mediaItems length: ${this.mediaItems.length}`);
      const { history, lightGallery, lgData } = window;
      const { item } = this.modal;
      // Remove hash
      history.pushState('', document.title, window.location.pathname + window.location.search);
      this.closeModal(item);
      if (this.isDynamicLoad) {
        this.isDynamicLoad = false; // Reset var so doesn't run again
        // Reload plugin and attach events to gallery
        const lgUid = lgData[this.lgDiv.getAttribute('lg-uid')];
        if (lgUid) {
          lgUid.destroy(true);
        }
        lightGallery(this.lgDiv, {
          counter: false,
          download: false,
          keyPress: false,
          preload: 3,
          selector: '.gallery-item-image',
          share: false,
          speed: 250,
        });
      }
    };
  }

  update(options) {
    const { lightGallery, lgData } = window;
    this.isComplete = options.isComplete;
    this.mediaItems = options.mediaItems;
    this.lgDiv = document.getElementById('media-gallery-list');
    if (!this.lgDiv.getAttribute('data-events-added')) {
      this.lgDiv.addEventListener('onAfterSlide', this.onUpdate);
      this.lgDiv.addEventListener('onCloseAfter', this.onClose);
      this.lgDiv.setAttribute('data-events-added', 'true');
    }
    if (this.isComplete) {
      const hashItem = this.getHashItem();
      // Initialize w/ hashed item loaded
      if (hashItem) {
        this.isDynamicLoad = true;
        lightGallery(this.lgDiv, {
          counter: false,
          download: false,
          dynamic: true,
          dynamicEl: [{
            src: hashItem.imageUrl,
          }],
          keyPress: false,
          share: false,
        });
        this.openModal(hashItem);
        // Initialize gallery
      } else {
        // Reload plugin and attach events to gallery
        const lgUid = lgData[this.lgDiv.getAttribute('lg-uid')];
        if (lgUid) {
          lgUid.destroy(true);
        }
        lightGallery(this.lgDiv, {
          counter: false,
          download: false,
          keyPress: false,
          preload: 3,
          selector: '.gallery-item-image',
          share: false,
          speed: 250,
        });
      }
    }
  }
}

class MediaGallery extends Component {
  constructor(props) {
    super(props);
    this.itemsAdded = 0;
    this.allAssetsLoaded = false;
    this.currentMediaItems = [];
    this.lg = new LightGalleryUtils(props);
  }

  componentDidUpdate() {
    const {
      assetLoadComplete,
      filterClick,
      filters,
      mediaItems,
    } = this.props;
    if (assetLoadComplete && !this.allAssetsLoaded) {
      // Only runs once, on complete
      this.allAssetsLoaded = true;
      Lazyload();
      this.lg.update({
        isComplete: true,
        mediaItems,
      });
      // Set default media (Images/Video), if one is checked
      const mediaOptions = filters.imagesVideosFilter.options;
      filterClick(mediaOptions[0]);
      // this.updateFilterGroupProperties();
      // Button for toggling filter content
      // Needs to run AFTER content has been added to DOM
      setTimeout(() => {
        const filterToggle = new ToggleContentToModal({
          callbacks: {
            onOpen: () => {
              filters.colorRangeFilter.active = true;
              filters.designStyleFilter.active = true;
              filters.productLineFilter.active = true;
              filters.roomTypeFilter.active = true;
            },
            onClose: () => {
              filters.colorRangeFilter.active = true;
              filters.designStyleFilter.active = true;
              filters.productLineFilter.active = true;
              filters.roomTypeFilter.active = true;
            },
          },
          modalId: 'filter-and-sort-modal',
          toggleSelector: '.btn-filter-sort',
          toggleContent: [
            {
              content: '.product-filter-group',
              modalSelector: '#filter-and-sort-modal .product-filter-wrapper',
              defaultSelector: '.filtered-content-grid .product-filter-wrapper',
            },
          ],
        });
      }, 100);
      InPageNav();
    }
    if (assetLoadComplete) {
      if (this.isNewMediaData()) {
        Lazyload();
        this.lg.update({
          isComplete: true,
          mediaItems,
        });
      }
      // Update currentMediaItems array
      this.currentMediaItems = mediaItems;
    }
  }


  isNewMediaData() {
    const { mediaItems } = this.props;
    // console.log(`mediaItems: ${mediaItems.length}, currentMediaItems: ${this.currentMediaItems.length}`);
    // console.log(mediaItems[0]);
    if (mediaItems.length !== this.currentMediaItems.length) {
      return true;
    }
    // Run through array and compare position by position
    for (let i = 0; i < mediaItems.length; i++) { /* eslint-disable-line no-plusplus */
      if (mediaItems[i].id !== this.currentMediaItems[i].id) {
        return true;
      }
    }
    return false;
  }

  render() {
    const {
      filters,
      buttonClick,
      filterClick,
      clearFilters,
      showAllFilterItems,
      modal,
      mediaItems,
      openModal,
      closeModal,
      savedToFavorites,
      assetId,
      assetLoadComplete,
    } = this.props;

    const secondaryFilters = Object.assign({}, {
      productLineFilter: filters.productLineFilter,
      colorRangeFilter: filters.colorRangeFilter,
      designStyleFilter: filters.designStyleFilter,
      roomTypeFilter: filters.roomTypeFilter,
    });

    const tabItemClick = (option) => {
      const mediaOptions = filters.imagesVideosFilter.options;
      Object.keys(mediaOptions).map((filterKey) => {
        if (mediaOptions[filterKey].name === option.name) {
          filterClick(mediaOptions[filterKey]);
          clearFilters();
        }
        return false;
      });
    };

    let showVideos = false;
    if (filters.imagesVideosFilter.options.length > 0) {
      if (!filters.imagesVideosFilter.options[0].isChecked) {
        showVideos = true;
      }
    }

    return (
      <div className="media-gallery-container mb-80">
        {filters.imagesVideosFilter.options.length > 1
          && (
            <section className="in-page-nav nav-links-only px-0 mb-40">
              <div className="container-xxl">
                <div className="row">
                  <div className="col-12">
                    <ul className="d-flex flex-row" role="tablist">
                      {filters.imagesVideosFilter.options.map(option => (
                        <FilterTabItem key={option.id} option={option} filterClick={tabItemClick} productRatingImagePath={filters.productRatingImagePath} />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )
        }
        <div className={`${(showVideos || !assetLoadComplete) ? 'hidden' : ''} container-xxl mt-1 mb-3`}>
          <div className="row">
            <div className="col product-sort-filter-btn-group">
              <button className="btn-icon btn-filter-sort">Filter &amp; Sort</button>
            </div>
          </div>
        </div>
        <div className={`${(!assetLoadComplete) ? 'loading-content-grid' : ''} container-xxl filtered-content-grid`}>
          <div className="row">
            {!showVideos // Show videos
              && (
                <div className="col-12 col-md-3 media-gallery-filter product-filter-wrapper pl-4 pl-xxl-0">
                  <var className="result-total-label sr-only" role="status" aria-live="assertive">Gallery updated, {mediaItems.length} items shown</var>
                  <a className="sr-only sr-only-focusable" href="#media-gallery-list">Skip filters and go to gallery</a>
                  <div className="product-filter-group">
                    <div className="filter-section-heading">
                      <h2 className="h6 sans-serif">Filter<span className="sr-only"> Gallery</span></h2>
                      <button className="button-reset clear-btn" type="button" onClick={() => clearFilters()}><div className="icon" /><span>Clear All</span><span className="sr-only"> Gallery Filters</span></button>
                    </div>
                    <FilterSetList filters={secondaryFilters} filterClick={filterClick} buttonClick={buttonClick} showAllFilterItems={showAllFilterItems} />
                  </div>
                </div>
              )
            }
            <div className={(showVideos) ? 'col-12' : 'col-12 col-md-9 px-0 pl-md-5 pr-md-2'}>
              <section className="media-gallery-content" role="tabpanel">
                {!assetLoadComplete
                  && (
                    <div className="media-gallery-load-overlay">
                      <div className="asset-loader">
                        <div className="ldr-dual-ring" />
                      </div>
                    </div>
                  )
                }
                <MediaGalleryList items={mediaItems} handleMediaClick={openModal} />
              </section>
            </div>
          </div>
        </div>
        <Modal
          modal={modal}
          savedToFavorites={savedToFavorites}
          assetId={assetId}
          handleModalClick={closeModal}
          updateModal={openModal}
        />
      </div>
    );
  }
}

MediaGallery.propTypes = {
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  buttonClick: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  showAllFilterItems: PropTypes.func.isRequired,
  filters: PropTypes.shape(PropTypes.object),
  modal: PropTypes.shape(PropTypes.object),
  mediaItems: PropTypes.arrayOf(PropTypes.object),
  savedToFavorites: PropTypes.bool.isRequired,
  assetId: PropTypes.string.isRequired,
  assetLoadComplete: PropTypes.bool.isRequired,
};

export default MediaGallery;
/* eslint-enable no-console, no-unused-vars */
